import React, { useMemo, useState } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import SelectionModal from "../modals/selectionModal/SelectionModal";
import { getIcon } from "../../../utils/iconConfig";
import { useGlobalContext } from "../../../context/GlobalContext";
import TabSkeleton from "../TabSkeleton";

const CartDetails = () => {
  const { details, cartData } = useGlobalContext();

  const [selectionModal, setSelectionModal] = useState(false);
  const [selectionTab, setSelectionTab] = useState("category");

  // Distinct collections from which designs have been added
  const collectionCartCount = useMemo(
    () => new Set(cartData.filter((d) => !!d.fromCollectionId).map((d) => d.fromCollectionId)).size,
    [cartData]
  );

  const cartDetails = [
    {
      icon: getIcon("Diamond", "coloured"),
      value: `${parseFloat(details?.diamondWeight).toFixed(3)} ct`,
      cursor: false,
    },
    {
      icon: getIcon("GoldBar", "coloured"),
      value: `${parseFloat(details?.goldWeight).toFixed(3)} g`,
      cursor: false,
    },
    { icon: getIcon("Ring"), value: `${details?.designCount}`, cursor: false },
    {
      icon: getIcon("Category"),
      value: `${details?.categories}`,
      cursor: true,
      tab: "category",
    },
    {
      icon: getIcon("Catalog"),
      value: `${collectionCartCount}`,
      cursor: true,
      tab: "collection",
    },
  ];

  // if (!cartData?.length) return null;

  return (
    <>
      <div
        style={{
          color: "white",
          width: "100%",
          height: "11vh",
          background: "#000000",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          padding: "1vw",
          borderRight: ".1vw solid #0d0d0d",
          borderBottom: ".1vw solid #0d0d0d",
        }}
      >
        <div
          style={{
            width: "21vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: ".5vw",
              width: "100%",
            }}
          >
            {/* designCount is the cart length, so it is zero only in the gap
                before the totals are worked out. Every value being zero also
                describes a real cart of weightless items, which left this
                stuck on the skeleton. */}
            {cartData?.length && !details?.designCount ? (
              <TabSkeleton
                height={"3vw"}
                width={"3.5vw"}
                count={5}
                borderRadius={".5vw"}
              />
            ) : (
              cartDetails?.map((data, index) => (
                <Card
                  key={index}
                  sx={{
                    background: "#0D0D0D",
                    color: "white",
                    width: "3.8vw",
                    height: "3vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: ".25vw",
                    cursor: data?.cursor ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (!data?.tab) return;
                    setSelectionTab(data.tab);
                    setSelectionModal(true);
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      gap: ".05vw",
                    }}
                  >
                    <Box>{data.icon}</Box>
                    <Typography
                      fontFamily="Poppins"
                      fontWeight="400"
                      fontSize=".6vw"
                      lineHeight="100%"
                      whiteSpace="nowrap"
                    >
                      {data.value}
                    </Typography>
                  </CardContent>
                </Card>
              ))
            )}
          </div>
        </div>
      </div>
      <SelectionModal
        openModal={selectionModal}
        initialTab={selectionTab}
        handleClose={() => setSelectionModal(false)}
      />
    </>
  );
};

export default CartDetails;
